import { getIsDateAvailableProducts } from './availabilityCalendar';

export const getImage = (id) => {
  if (typeof drupalSettings !== 'undefined'
      && drupalSettings?.assistedNavApp?.images?.[id]) {
    return drupalSettings.assistedNavApp.images[id];
  }
  return {};
};

export const getSales = () => (typeof drupalSettings !== 'undefined' ? drupalSettings?.assistedNavApp?.sales ?? '' : '');

/**
 * Check if given date is lowest price for the month.
 *
 * @param {*} productsResponse
 * @param {*} date
 * @param {*} selectProduct
 * @param {*} today
 * @returns
 */
export const isLowestPriceDate = (productsResponse, date, selectProduct, today = null) => {
  if (!Array.isArray(productsResponse) || productsResponse.length === 0) return false;

  if (!getIsDateAvailableProducts(productsResponse, date, today)) return false;

  const targetDate = new Date(date);
  const targetDay = targetDate.getDate();
  const targetMonth = targetDate.getMonth();
  const targetYear = targetDate.getFullYear();

  return productsResponse.some((productResponse) => {
    const { data } = productResponse;
    if (data?.id !== selectProduct.id || !Array.isArray(data.tickets)) return false;

    return data.tickets.some((ticket) => {
      if (ticket.type !== 'Adult' || !Array.isArray(ticket.availability)) return false;

      const sameMonthData = ticket.availability.filter((entry) => {
        const d = new Date(entry.date);
        return d.getMonth() === targetMonth && d.getFullYear() === targetYear;
      });

      if (sameMonthData.length === 0) return false;

      const minPrice = Math.min(...sameMonthData.map((entry) => parseFloat(entry.price)));

      return sameMonthData.some((entry) => {
        const d = new Date(entry.date);
        return (
          d.getDate() === targetDay
          && d.getMonth() === targetMonth
          && d.getFullYear() === targetYear
          && parseFloat(entry.price) === minPrice
        );
      });
    });
  });
};

export const scrollWithOffset = (el, offset = 100) => {
  const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
};

export const getCookie = (name) => {
  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));

  const value = cookie ? cookie.split('=')[1] : null;

  if (value === '1') return true;
  if (value === '0') return false;

  return value;
};
